const Update_Job_Debounce =   job_debounce(Update_Job_Name, 1000)

Initialize_Save_Cart()
document.addEventListener("on:full-refresh-finish",Reload_Drawer_Bindings)
document.addEventListener("on:line-item:change",Reload_Drawer_Bindings)



function Reload_Drawer_Bindings(){
  console.log("RELOAD")
  setTimeout(()=>{  let cart = document.getElementById("cart-drawer");
    if (cart == undefined){
      cart = document.getElementById("cart-summary");
    }
    if (cart != undefined){
      cart.querySelectorAll('[name="save-cart"]').forEach((element) => {element.addEventListener('click', Save_Cart); console.log(element)});
      cart.querySelectorAll('[name="save-as-cart"]').forEach((element) => element.addEventListener('click', Save_Cart));
      cart.querySelectorAll('[name="new-job"]').forEach((element) => element.addEventListener('click', Clear_Cart));
      cart.querySelector("#job-name").addEventListener('input', Update_Job_Debounce);}
  }  ,100)
}

function Initialize_Save_Cart(){
  document.getElementsByName("save-cart").forEach((element) => {element.addEventListener('click', Save_Cart)});
  document.getElementsByName("save-as-cart").forEach((element) => element.addEventListener('click', Save_Cart));
  document.getElementById("job-name").addEventListener('input', Update_Job_Debounce);
  document.getElementsByName("new-job").forEach((element) => element.addEventListener('click', Clear_Cart));
  
  setTimeout(Get_Carts,100)
  document.getElementsByName("load-share-cart").forEach((element) => {
    let urlSearch = new URLSearchParams(window.location.search);
    if (urlSearch.get("id") != undefined){
      element.setAttribute("data-cart-id",urlSearch.get("id"))
      element.addEventListener('click', Load_Cart)
    } else{
      element.setAttribute("disabled","")
    }
    });
}

function Refresh_Cart(){
  if (window.location.pathname =="/cart"){
    window.location.reload();
    
  }else{
    setTimeout(document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh' , {bubbles: true})),250)
    setTimeout(document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open' , {bubbles: true})),250)
      
  }
}


function Get_Job_Name(){
    fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET'
  })
  .then(response => response.json())
  .then(answer => {
    let cartData = answer
    if ("attributes" in cartData && "Job Name" in cartData["attributes"]){
      document.getElementById("job-name").value = cartData["attributes"]["Job Name"]
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });

}

function Load_Clear_Cart(data){
    var formData = new FormData();
    
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(answer => {
      console.log("Cleared")
      setTimeout(Load_Cart_Data(data),250)
    })
}


function Update_Job_Name(){
  var formData = new FormData();
  formData.append("attributes[Job Name]", document.getElementById("job-name").value);
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(answer => {
    console.log(answer)
    //console.log("Job Name Updated")

  })
  
}

function Update_Cart_ID(){
  var formData = new FormData();
  formData.append("attributes[_cart-id]", document.getElementsByName("save-cart")[0].getAttribute("data-cart-id"));
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(answer => {
    //console.log("Job Name Updated")

  })
  
}
  
function Save_Cart(event) {
  Update_Job_Name()
  
  let urlTarget = "https://mke-cabinetry.anvil.app/_/api/save-cart";
    
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET'
  })
  .then(response => response.json())
  .then(answer => {
    let cartData = answer
    cartData["customer_id"] = event.target.getAttribute("data-customer-id")
    cartData["verify"] = event.target.getAttribute("data-verify")
    cartData["cart-id"] = event.target.getAttribute("data-cart-id")
    cartData["mode"] = event.target.getAttribute("data-cart-mode")
    cartData["cart_image"] = document.querySelector(".cart-item__image img").src
    cartData["multi_cart_images"] = []

    let count = 0
    let max_images = 4
    for (element of document.querySelectorAll("[data-cart-save-images]")){
      let save_image_urls = element.getAttribute("data-cart-save-images").split(" ")
      for(image_url of save_image_urls){
        if(!(cartData["multi_cart_images"].includes(image_url))){
          cartData["multi_cart_images"].push(image_url)
          count+= 1
        }
        if (count >= max_images){
          break
        }        
      }

    }
    for (element of document.querySelectorAll(".cart-item__image img")){
      cartData["multi_cart_images"].push(element.src)
      count+=1
      if (count >= max_images){
        break
      }
    }

    if ("attributes" in cartData){
      cartData["attributes"]["Job Name"] = document.getElementById("job-name").value
      
      
    }else{
      cartData["attributes"] = {}
      cartData["attributes"]["Job Name"] = document.getElementById("job-name").value
    }
    
    
    fetch(urlTarget, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData)
    })
    .then(response => response.json())
    .then(answer => {
      let old_html = event.target.innerHTML;
      event.target.innerHTML = "Job Saved!"
      event.target.classList.toggle("success-btn")
      setTimeout(()=>{
        event.target.classList.toggle("success-btn");
        event.target.innerHTML = old_html;
        },2500)
      document.getElementsByName("save-cart").forEach((element) => element.setAttribute("data-cart-id",answer['id']));
      Update_Cart_ID()
      setTimeout(Get_Carts,1000)
      
    })
    .catch((error) => {
      console.error('Error:', error);
    });

    
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  
}

  
function Delete_Cart(event) {  
  if(confirm("Are you sure you want to delete this cart?")){
    let urlTarget = "https://mke-cabinetry.anvil.app/_/api/delete-cart";
    
    let cartData = {}
    cartData["customer_id"] = event.target.getAttribute("data-customer-id")
    cartData["verify"] = event.target.getAttribute("data-verify")
    cartData["cart-id"] = event.target.getAttribute("data-cart-id")
    
    fetch(urlTarget, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData)
    })
    .then(response => response.json())
    .then(answer => {
      Get_Carts()
  
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    
  }

}

function Share_Cart(event) {  
  let urlTarget = "https://mke-cabinetry.anvil.app/_/api/share-cart";
  
  let cartData = {}
  cartData["customer_id"] = document.getElementById("slider-load-jobs").getAttribute("data-customer-id")
  cartData["verify"] = document.getElementById("slider-load-jobs").getAttribute("data-verify")
  cartData["cart-id"] = event.target.getAttribute("data-cart-id")
  
  fetch(urlTarget, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(cartData)
  })
  .then(response => response.json())
  .then(answer => {
    navigator.clipboard.writeText(answer["share_link"]);
    event.target.innerHTML = "Link Copied!"
    event.target.classList.toggle("success-btn")
    setTimeout(()=>{
      event.target.classList.toggle("success-btn");
      event.target.innerHTML = "Get Share Link"
                   },2500)

  })
  .catch((error) => {
    console.error('Error:', error);
  })
}

function Get_Carts(){
  console.log("Get_Carts")
  
  let job_list = document.getElementById("jobs-list")
  
  if (job_list != null){
    
    let urlTarget = "https://mke-cabinetry.anvil.app/_/api/get-carts";
    
    let cartData = {}
    cartData["customer_id"] = document.getElementById("slider-load-jobs").getAttribute("data-customer-id")
    cartData["verify"] = document.getElementById("slider-load-jobs").getAttribute("data-verify")
    
    fetch(urlTarget, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData)
    })
    .then(response => response.json())
    .then(answer => {
      
      console.log("Get Carts")
      job_list.innerHTML = ""
      let carts = answer["carts"]
      document.getElementById("slider-load-jobs").classList.toggle("visually-hidden", carts.length == 0);
      document.getElementById("slider-no-jobs-notice-load").classList.toggle("visually-hidden", carts.length != 0);
      carts.forEach((cart) => Create_Cart(cart));

    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}


function Clear_Cart(event){
  if(confirm("Are you sure you want to clear your cart?")){
    
    var formData_clear = new FormData();
    
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      body: formData_clear
    })
    .then(response => response.json())
    .then(answer => {
      console.log(answer)
    
      var formData = new FormData();
      document.getElementById("job-name").value = ""
      formData.append("attributes[Job Name]", document.getElementById("job-name").value);
      
      document.getElementsByName("save-cart").forEach((element) => {element.removeAttribute("data-cart-id")});
      formData.append("attributes[_cart-id]", document.getElementsByName("save-cart")[0].getAttribute("data-cart-id"));
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(answer => {
        console.log(answer)
        Refresh_Cart()
        
        //console.log("Job Name Updated")
      })
    })
  }
}


function Load_Cart(event){
  if(confirm("Are you sure you want to load this cart? It will overwrite the contents your current cart contents.")){
    console.log("Load_Cart")
    
    let urlTarget = "https://mke-cabinetry.anvil.app/_/api/load-cart";
    
    let cartData = {}
    cartData["customer_id"] = event.target.getAttribute("data-customer-id")
    cartData["verify"] = event.target.getAttribute("data-verify")
    cartData["cart-id"] = event.target.getAttribute("data-cart-id")
    
    fetch(urlTarget, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData)
    })
    .then(response => response.json())
    .then(answer => {
      Load_Clear_Cart(answer)
      document.getElementsByName("save-cart").forEach((element) => element.setAttribute("data-cart-id",answer['id']));
  
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function Load_Cart_Data(data){
  let formData = {
   'items': [],
    "attributes":{},
    "note":""
  };

  let items = data["contents"]['items'].reverse();
  items.forEach((item) => formData["items"].push({
    'id': item["variant_id"],
    'quantity': item["quantity"],
     "properties":item["properties"]
    }))
  
  let attributes = data["contents"]['attributes']
  Object.keys(attributes).forEach((attribute) =>   formData["attributes"][attribute] = attributes[attribute])
  formData["attributes"]["_cart-id"] = data["id"]

  formData["note"] = data["contents"]['note']
  
  console.log(formData)
  console.log(JSON.stringify(formData))
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(answer => {
    Refresh_Cart()

  })
  
}

function Create_Cart(cart){
  let job_list = document.getElementById("jobs-list")
  
  const Cart_Listing = document.createElement("li");
  Cart_Listing.classList.add("slider__item","cc-animate-init","cc-animate-in")
  Cart_Listing.setAttribute("data-cc-animate","")
  Cart_Listing.setAttribute("data-cc-animate-dela","0.07s")
  Cart_Listing.setAttribute("style","animation-delay: 0.07s;")

  
  const Card = document.createElement("card");
  Cart_Listing.appendChild(Card)  

  const CardDiv = document.createElement("div");
  CardDiv.classList.add("card__media","relative","text-center")
  Card.appendChild(CardDiv)  

  const Anchor = document.createElement("div");
  Anchor.classList.add("card__media","relative")
  //Anchor.setAttribute("href","/")
  CardDiv.appendChild(Anchor)  

  const ImagePanel = document.createElement("div");
  ImagePanel.classList.add("relative","multi-image-4-panel")
  Anchor.appendChild(ImagePanel) 

  let count = 0
  for (image of cart['multi_cart_images']){
    const ImgDiv = document.createElement("div")
    ImgDiv.classList.add("card__media","relative",`item${count}`)
    ImagePanel.appendChild(ImgDiv) 

    const Image = document.createElement("img");
    Image.classList.add("card__media","relative")
    Image.src = image
    
    ImgDiv.appendChild(Image) 
    count += 1
    if (count >= 3){
      break
    }
  }
    
  const Info = document.createElement("div");
  Info.classList.add("card__info-container","flex","flex-col","flex-auto","relative","color-scheme","color-scheme--2","info-cart-card")
  CardDiv.appendChild(Info)

  const Title = document.createElement("h4");
  Title.classList.add("card__title","font-bold","h5")
  Title.innerHTML = cart["name"]
  Info.appendChild(Title)

  const UpdateDate = document.createElement("p");
  UpdateDate.classList.add("card__title","font-bold")
  UpdateDate.innerHTML = cart["last_updated"]
  Info.appendChild(UpdateDate)
  
  const ButtonFrame = document.createElement("div");
  ButtonFrame.classList.add("card__title","font-bold")
  Info.appendChild(ButtonFrame)

  let slider = document.getElementById("slider-load-jobs")
  
  const ShareButton = document.createElement("button");
  ShareButton.classList.add("btn","btn--primary","w-full","mb-2")
  ShareButton.setAttribute("data-cart-id",cart["id"])
  
  if (cart["shared"]){
    ShareButton.innerHTML = "Get Share Link"
  }else{
    ShareButton.innerHTML = "Allow Sharing"
  }
  ShareButton.addEventListener("click",Share_Cart)
  ShareButton.setAttribute("data-customer-id", slider.getAttribute("data-customer-id"))
  ShareButton.setAttribute("data-verify", slider.getAttribute("data-verify"))
  
  ButtonFrame.appendChild(ShareButton)


  const LoadButton = document.createElement("button");
  LoadButton.classList.add("btn","btn--primary","w-full","mb-2")
  LoadButton.innerHTML = "Load"
  LoadButton.addEventListener("click",Load_Cart)
  LoadButton.setAttribute("data-cart-id",cart["id"])
  LoadButton.setAttribute("data-customer-id", slider.getAttribute("data-customer-id"))
  LoadButton.setAttribute("data-verify", slider.getAttribute("data-verify"))

  ButtonFrame.appendChild(LoadButton)

  const DeleteButton = document.createElement("button");
  DeleteButton.classList.add("btn","btn--primary","w-full")
  DeleteButton.innerHTML = "Delete"
  DeleteButton.setAttribute("data-cart-id",cart["id"])
  DeleteButton.setAttribute("data-customer-id", slider.getAttribute("data-customer-id"))
  DeleteButton.setAttribute("data-verify", slider.getAttribute("data-verify"))
  DeleteButton.addEventListener("click",Delete_Cart)
  ButtonFrame.appendChild(DeleteButton)
  
  job_list.appendChild(Cart_Listing)

}

function job_debounce(callback, delay) {
    let timer
    return function() {
      clearTimeout(timer)
      timer = setTimeout(() => {
        callback();
      }, delay)
    }
  }

